import {
  ClinicalTrialDetailType,
  ClinicalTrialUpdateType,
} from '@dynamika-shared/types/clinicalTrials';

const emptyCT: ClinicalTrialUpdateType = {
  name: '',
  code: '',
  sponsorId: '',
  dataStorageLocationId: '',
  description: '',
  iagStudyEmail: '',
  dashboardUrl: '',
  ctGovLink: '',
  eudraCt: '',
  phase: '',
  therapeuticArea: '',
  disease: '',
  drugMolecule: '',
  dicomViewerVersion: '',
  startDate: '',
  endDate: '',
  firstPatientVisit: '',
  lastPatientVisit: '',
  siteHypothesis: 0,
  patientHypothesis: 0,
  visitHypothesis: 0,
};
export const convertToClinicalTrialUpdate = (
  detail?: ClinicalTrialDetailType | null
): ClinicalTrialUpdateType => {
  if (!detail) return emptyCT;
  return {
    name: detail.name,
    code: detail.code ?? '',
    sponsorId: detail.sponsorId,
    dataStorageLocationId: detail.dataStorageLocationId ?? '',
    description: detail.description ?? '',
    iagStudyEmail: detail.iagStudyEmail ?? '',
    dashboardUrl: detail.dashboardUrl ?? '',
    ctGovLink: detail.ctGovLink ?? '',
    eudraCt: detail.eudraCt ?? '',
    phase: detail.phase ?? '',
    therapeuticArea: detail.therapeuticArea ?? '',
    disease: detail.disease ?? '',
    drugMolecule: detail.drugMolecule ?? '',
    dicomViewerVersion: detail.dicomViewerVersion ?? '',
    startDate: detail.startDate,
    endDate: detail.endDate,
    firstPatientVisit: detail.firstPatientVisit,
    lastPatientVisit: detail.lastPatientVisit,
    siteHypothesis: detail.siteHypothesis ?? 0,
    patientHypothesis: detail.patientHypothesis ?? 0,
    visitHypothesis: detail.visitHypothesis ?? 0,
  };
};
